document.addEventListener('DOMContentLoaded', async function() {
    const locationDropdown = document.querySelector('.location-dropdown');
    const errorNotification = document.querySelector('.error-notification');
    const errorCloseBtn = document.querySelector('.error-notification-close');
    const shopDomain = window.shopDomain
    let errorTimeout;
    errorCloseBtn?.addEventListener('click', () => {
        errorNotification.classList.remove('show');
        if (errorTimeout) {
            clearTimeout(errorTimeout);
        }
    });
  
    if (locationDropdown) {
        locationDropdown?.addEventListener('click', function(e) {
            e.stopPropagation();
            this?.classList.toggle('active');
        });
  
        document.addEventListener('click', function(e) {
            if (!locationDropdown?.contains(e.target)) {
                locationDropdown?.classList.remove('active');
            }
        });
    }
  });